module.exports = __webpack_public_path__ + "static/img/6-3.faf0264.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/6-3.png
// module id = MSwB
// module chunks = 0